import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Canvas, FabricImage, Textbox, Group } from 'fabric'; // browser
import { QRCodeModule, QRCodeComponent } from 'angularx-qrcode';
import { Edizione, directus } from '../../../../directus';
import { readItem } from '@directus/sdk';
import { CommonModule } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';

import { environment } from '../../../environments/environment';
import { EdizioneObj } from '../../classes/edizione-obj';

@Component({
  selector: 'app-canvas-badge',
  standalone: true,
  imports: [CommonModule, QRCodeModule],
  templateUrl: './canvas-badge.component.html',
  styleUrl: './canvas-badge.component.css'
})
export class CanvasBadgeComponent implements OnInit, AfterViewInit {

  @Input() edizione_id: string | undefined;
  protected edizione: Edizione | undefined;

  qrdata: string = '0';
  init: boolean = true;

  iscrizioneText = 'Mario Rossi\nAcme Inc';

  @ViewChild('div_canvas_wrapper ')
  myIdentifier: ElementRef | undefined;

  @ViewChild(QRCodeComponent)
  parent_qrcode!: QRCodeComponent;

  @ViewChild('noinit')
  noinit!: ElementRef | undefined;

  hidden_canvas: any;



  protected _imgPreview: any = null;
  isModalBadgeOpen = false;
  print_error: string = "";

  imageB64Path: any = "";

  logo: string = environment.apiUrl + '/assets/b06813b5-e626-455d-b8d7-f88acf6b9244.png';

  imageHeight = 75;
  imageWidth = 75;

  h_badge = "h-64";

  constructor(private _sanitizer: DomSanitizer) {}

  ngOnInit(): void { }

  ngAfterViewInit() {
    //if (this.myIdentifier) {
    //  var width = this.myIdentifier.nativeElement.offsetWidth;
    //  var height = this.myIdentifier.nativeElement.offsetHeight;
    //
    //console.log('Width:' + width);
    //console.log('Height: ' + height);
    //}
    if (this.edizione_id && this.noinit == undefined)
      this.setEdizioneById(this.edizione_id);
  }

  async setEdizioneById(id: string, _reinit: boolean = false): Promise<string> {
    //@ts-ignore
    const _ed: Edizione = await directus
      .request<Edizione>(readItem('edizione', id));

    this.edizione = _ed;

    if (!_reinit)
      return this.initBadge();
    else
      return this.reinitBage();
  }
  async setEdizioneByObject(_ed: EdizioneObj, _reinit: boolean = false): Promise<string> {

    this.edizione = _ed;

    if (!_reinit)
      return this.initBadge();
    else
      return this.reinitBage();
  }
  onResize(event: any) {
    // alert(event.width + " x " + event.height);

    //this.resizeCanvas(this.canvas, event.width, event.height)
  }
  setBadgeURL(_URL: string): string {
    if (_URL) {
      this.qrdata = _URL;
    }
    return this.qrdata;
  }
  setBadgeText(_text: string): string {
    if (_text) {
      this.iscrizioneText = _text;
    } else {
      this.iscrizioneText = "TEXT\nUNDEFINED";
    }
    return this.iscrizioneText;
  }
  async reinitBage(): Promise<string> {
    try {
      if (this.hidden_canvas) {
        this.hidden_canvas.clear();
        this.hidden_canvas.dispose();
        this.hidden_canvas = null;
      }
    } catch (error: any) {
      alert(error.message);
    }
    return this.initBadge();
  }
  initBadge(): Promise<string> {
    //this.edizione = {...this._edizione};
    const self = this;
    return new Promise((resolve, reject) => {
      try {

        if (self.edizione && self.edizione?.badge) {

          if (!self.hidden_canvas) {
            self.hidden_canvas = new Canvas('hidden_canvas', {
              interactive: false,
              selectable: false,
              backgroundColor: '#ffffff',
              width: (self.edizione?.bw ? self.edizione.bw : environment.bw),
              height: (self.edizione?.bh ? self.edizione.bh : environment.bh)
            });
          }
          self.getBase64ImageFromUrl(environment.apiUrl + '/assets/' + self.edizione?.badge)
            .then(async result => {
              //console.log('BASE&$ BADGE', result);

              var imgH = await FabricImage.fromURL(result as string);
              //var scaleWidth = self.hidden_canvas.getWidth() / imgH.width;
              //var scaleHeight = self.hidden_canvas.getHeight() / imgH.height;
              //var scale = Math.min(scaleWidth, scaleHeight);

              //imgH.scaleToWidth(self.edizione?.bw);
              //imgH.scaleToHeight(self.edizione?.bh);
              //imgH.scaleX = scaleWidth;
              //imgH.scaleY = scaleHeight;
              //imgH.set({ top: 0, left: 0, crossorigin: false });
              //imgH.selectable = false;


              // create text
              var textH = new Textbox(self.iscrizioneText, {
                left: (self.edizione?.tx ? self.edizione.tx : environment.tx),
                top: (self.edizione?.ty ? self.edizione.ty : environment.ty),
                width: (self.edizione?.bw ? (self.edizione.bw - 100) : environment.bw),
                fontSize: self.edizione?.b_font_size,
                fontFamily: 'Syne',
                fill: 'black',
                selectable: false
              });
              const _imgB64 = self.getB64QRCode();

              var _qrCodeH = await FabricImage.fromURL(_imgB64);
              //console.log('qrcode b64 ' + _imgB64);

              _qrCodeH.scaleToWidth(self.edizione?.qrcode_w);
              _qrCodeH.scaleToHeight(self.edizione?.qrcode_h);
              _qrCodeH.set({ top: self.edizione?.qrcode_y, left: self.edizione?.qrcode_x });
              _qrCodeH.selectable = false;

              var group2 = new Group([imgH, textH, _qrCodeH], {
                left: 0,
                top: 0,
              });
              self.hidden_canvas.selection = false;
              self.hidden_canvas.add(group2);
              self.hidden_canvas.renderAll();
              var dataURL = self.hidden_canvas.toDataURL({ format: 'png', quality: 1 });
              var imgUrl = dataURL.replace(/^data:image\/[^;]/, 'data:application/octet-stream');
              //console.log(dataURL);

              self.imageB64Path = self._sanitizer.bypassSecurityTrustResourceUrl(dataURL);

              if (self.myIdentifier) {
                var width = self.myIdentifier.nativeElement.offsetWidth;
                var height = self.myIdentifier.nativeElement.offsetHeight;

                //console.log('Width:' + width);
                //console.log('Height: ' + height);
                // self.resizeCanvas(self.canvas, width, height);
              }
              resolve(self.imageB64Path);
            })
            .catch(err => {
              console.error(err);
              reject(err);
            });
        }
      } catch (error: any) {
        alert(error.message);
        reject(error.message);
      }
    });

  }
  getImage(event: any): string {
    //alert();
    event.stopPropagation();
    const self = this;

    var dataURL = this.hidden_canvas.toDataURL('image/png', { multiplier: 4 });
    var imgUrl = dataURL.replace(/^data:image\/[^;]/, 'data:application/octet-stream');
    //console.log(dataURL);

    this.imageB64Path = this._sanitizer.bypassSecurityTrustResourceUrl(dataURL);
    this.openModal();
    return imgUrl;
  }
  resizeCanvas(__canvas: Canvas, w: any, h: any) {
    var canvasSizer = document.getElementById("canvasSizer");
    var canvasScaleFactor = w / 525;
    var width = w;
    var height = h;
    var ratio = __canvas.getWidth() / __canvas.getHeight();
    if ((width / height) > ratio) {
      width = height * ratio;
    } else {
      height = width / ratio;
    }
    var scale = width / __canvas.getWidth();
    var zoom = __canvas.getZoom();
    zoom *= scale;
    __canvas.setDimensions({ width: width, height: height });
    __canvas.setViewportTransform([zoom, 0, 0, zoom, 0, 0])
  };

  setPreviewHeight(_value: string) {
    if (!_value)
      return;

    this.h_badge = _value;
  }
  /*
  QRCODE
  */
  getB64QRCode(): string {
    // fetches base 64 date from image
    const parentElement = this.parent_qrcode.qrcElement.nativeElement.querySelector("img").src;

    // converts base 64 encoded image to blobData
    let blobData = this.convertBase64ToBlob(parentElement);
    //console.log("QRCODE BASE 64 ", parentElement);
    return parentElement;

    const blob = new Blob([blobData], { type: "image/png" });
    const url = window.URL.createObjectURL(blob);
    // window.open(url);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'Qrcode';
    link.click();

  }

  private convertBase64ToBlob(Base64Image: any) {
    // SPLIT INTO TWO PARTS
    const parts = Base64Image.split(';base64,');
    // HOLD THE CONTENT TYPE
    const imageType = parts[0].split(':')[1];
    // DECODE BASE64 STRING
    const decodedData = window.atob(parts[1]);
    // CREATE UNIT8ARRAY OF SIZE SAME AS ROW DATA LENGTH
    const uInt8Array = new Uint8Array(decodedData.length);
    // INSERT ALL CHARACTER CODE INTO UINT8ARRAY
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }
    // RETURN BLOB IMAGE AFTER CONVERSION
    return new Blob([uInt8Array], { type: imageType });
  }
  async getBase64ImageFromUrl(imageUrl: any) {
    var res = await fetch(imageUrl);
    var blob = await res.blob();

    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.addEventListener("load", function () {
        resolve(reader.result);
      }, false);

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    })
  }

  closeModal() {
    this.isModalBadgeOpen = false;
  }
  public openModal() {
    this.isModalBadgeOpen = true;
  }

}
